export const OffCanvas = (props) => {
	const close = (e) => {
		e.stopPropagation();
		props.close();
	};

	const stop = (e) => {
		e.stopPropagation();
	};

	return (
		<div
			className={"rbr-offcanvas " + (!!props.open ? "rbr-offcanvas-open" : "")}
			onClick={close}
		>
			<div
				className={`rbr-offcanvas-content ${props.contentClassName || ""}`.trim()}
				onClick={stop}
			>
				{props.children}
			</div>
		</div>
	);
};
